const fillProductCategories = (productCategories) => {
  return { type: 'FILL_PRODUCT_CATEGORIES', payload: productCategories };
};

export {
  fillProductCategories,
}